import AjudaService from "@/services/AjudaService";

export const ajuda = {
  namespaced: true,
  state: {
    ajuda: {},
  },
  actions: {
    getAjuda({ commit }, payload) {
      return AjudaService.GetAjuda(payload).then(
        (ajuda) => {
          return Promise.resolve(ajuda);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postAjuda({ commit }, payload) {
      return AjudaService.PostAjuda(payload).then(
        (ajuda) => {
          return Promise.resolve(ajuda);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putAjuda({ commit }, payload) {
      return AjudaService.PutAjuda(payload).then(
        (ajuda) => {
          return Promise.resolve(ajuda);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteAjuda({ commit }, payload) {
      return AjudaService.DeleteAjuda(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getAjudaOData({ commit }, payload) {
      return AjudaService.GetAjudaOData(payload).then(
        (ajuda) => {
          return Promise.resolve(ajuda);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    postAjudaUpload({ commit }, payload) {
      return AjudaService.PostAjudaUpload(payload).then(
        (ajudaUpload) => {
          return Promise.resolve(ajudaUpload);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteAjudaUpload({ commit }, payload) {
      return AjudaService.DeleteAjudaUpload(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getAjudasUsuario({ commit }, payload) {
      return AjudaService.GetAjudasUsuario(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default ajuda;
